import { render, staticRenderFns } from "./choosePop.vue?vue&type=template&id=a1e7a614&scoped=true"
import script from "./choosePop.vue?vue&type=script&lang=js"
export * from "./choosePop.vue?vue&type=script&lang=js"
import style0 from "./choosePop.vue?vue&type=style&index=0&id=a1e7a614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e7a614",
  null
  
)

export default component.exports